import type { Step } from '@lemonade-hq/chat-engine';
import type { WizardExtendedStepWithPersistence } from '@lemonade-hq/chat-wizard-client-base';
import type { I18nContextValue } from '@lemonade-hq/nuiza';
import type { UniclientStepPresentation } from '@lemonade-hq/uniclient-chat';
import { restart } from '@lemonade-hq/uniclient-chat';

interface ErrorPageParams {
  readonly s: I18nContextValue['s'];
}

export function errorStep410({
  s,
}: ErrorPageParams): WizardExtendedStepWithPersistence<Step<UniclientStepPresentation, unknown>> {
  return {
    name: 'error-gone',
    presentation: {
      frame: {
        title: s('chat.error.410.title'),
        action: restart({ content: s('chat.error.410.action') }),
      },
    },
  };
}
